import React, {useState,useEffect} from "react";
import { StyleSheet, Text, View, Button, ImageBackground,Image,Dimensions,TouchableOpacity, Switch,Alert} from "react-native";

import imgSrc2 from './images/clemgram_black.jpg';
import clem from './images/clemazonnn.png';
import clemg from './images/clemazon_g.png';
import clemazon_g_cookie from './images/customcookie.png';

import custom from './images/confirmchoices.png';
import acceptall from './images/acceptall.png';
import editt from './images/edit.png';


import { initializeApp } from "firebase/app";
import { getDatabase, ref, set,update } from "firebase/database";
//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
    // ...
    apiKey: "AIzaSyB3kIHJz7Ey5FXzUVsN5Gfjp8tBaG6xYbw",
      authDomain: "stress-and-privacy.firebaseapp.com",
    databaseURL: "https://stress-and-privacy-default-rtdb.firebaseio.com",
      projectId: "stress-and-privacy",
      storageBucket: "stress-and-privacy.appspot.com",
      messagingSenderId: "738098786959",
      appId: "1:738098786959:web:a6469cc294345688a476fa" 
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  
  
  // Initialize Realtime Database and get a reference to the service
  const database = getDatabase(app);

const Info = (props) => {
	const [cookie,setCookie]=useState('');
	const [location,setLocation]=useState('');
	const [isEnabled, setIsEnabled] = useState(true);
	const toggleSwitch = () => setIsEnabled(previousState => previousState);
	const [isEnabled2, setIsEnabled2] = useState(true);
	const toggleSwitch2 = () => setIsEnabled2(previousState => !previousState);
	const [isEnabled3, setIsEnabled3] = useState(true);
	const toggleSwitch3 = () => setIsEnabled3(previousState => !previousState);
	return( 
		           
		<View style={styles.container}>
			<ImageBackground source={clemg}  resizeMode='stretch' style={styles.ipro}>
		
		
			<ImageBackground source={clemazon_g_cookie}  resizeMode='center' style={styles.iedit}>
			<View style={{flexDirection:"column",alignItems:'left',justifyContent:'center',textAlign:'center',marginTop: Dimensions.get('window').height/6,}}>
				<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left',marginLeft:Dimensions.get('window').width/4,}}>	
				<Text style={styles.texti}>Strictly Necessary      </Text>
				<Switch
					trackColor={{ false: '#767577', true: '#81b0ff' }}
					thumbColor={isEnabled ? '#f5dd4b' : '#f4f3f4'}
					ios_backgroundColor="#3e3e3e"
					onValueChange={toggleSwitch}
					value={isEnabled}
				/>
				</View>
				<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left',marginLeft:Dimensions.get('window').width/4,}}>	
				<Text style={styles.texti}>Performance Cookies</Text>
				<Switch
					trackColor={{ false: '#767577', true: '#81b0ff' }}
					thumbColor={isEnabled ? '#f5dd4b' : '#f4f3f4'}
					ios_backgroundColor="#3e3e3e"
					onValueChange={toggleSwitch2}
					value={isEnabled2}
				/>
				</View>
				<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left',marginLeft:Dimensions.get('window').width/4,}}>	
				<Text style={styles.texti}>Targeted Cookies       </Text>
				<Switch
					trackColor={{ false: '#767577', true: '#81b0ff' }}
					thumbColor={isEnabled ? '#f5dd4b' : '#f4f3f4'}
					ios_backgroundColor="#3e3e3e"
					onValueChange={toggleSwitch3}
					value={isEnabled3}
				/>
				</View>
       		</View>
			<View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign: 'center',marginTop:10,marginLeft:30}}>
		
				<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center'}}
					onPress={() => {
						
						props.navigation.navigate('Clemazon2',{email: props.navigation.state.params.email});
					}}>
					<Image         
						style={styles.ichart}
						resizeMode={'center'}
						source={custom}/>
				</TouchableOpacity>
				<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginLeft:30}}
					onPress={() => {
						props.navigation.navigate('Clemazon2',{email: props.navigation.state.params.email});
					}}>
					<Image         
						style={styles.ichart}
						resizeMode={'center'}
						source={acceptall}/>
				</TouchableOpacity>
				</View>
			</ImageBackground>
				

			
				</ImageBackground>
		</View>
	
	)
	

}
//	{false}<Text style={styles.text4}>Your Facebook profile is where other people can post their thoughts, opinions, views, or criticisms about you for everyone to see. </Text>
                               
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"black",
	},
	button: {
		alignItems: "center",
		backgroundColor: "#DDDDDD",
		padding: 10
	  },
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'center',
        flexDirection: "column",
		justifyContent: "center",
	},
	ichart: {
		height: Dimensions.get('window').height/10,
		width: Dimensions.get('window').width/8,
	  }, 
	  iedit: {
		marginTop:Dimensions.get('window').height/4,
		height: Dimensions.get('window').height/2.5,
		width: Dimensions.get('window').width/1.5,
		alignSelf: 'center',
		textAlign: 'center',
		justifyContent: "center",
	  }, 
	  ipro: {
		height: Dimensions.get('window').height,
		width: Dimensions.get('window').width,
	  }, 
	  ipost: {
		height: Dimensions.get('window').height/3.5,
		width: Dimensions.get('window').width/3.5,
	  },
	buttonContainer:{
		width: '15%',
		alignSelf: 'center',
		marginTop: 80,
	},
	iweb2: {
		height: Dimensions.get('window').height/2.7,
		width: Dimensions.get('window').width/4,
		marginLeft: 1
	  },
	text: {
		
		fontSize: Dimensions.get('window').width/50,
		color:'#3a9BDC',
		marginRight: 5,
		marginLeft: 5,
	},
	texti: {
		fontWeight: "bold",
		fontSize: 16,
		marginRight: 5,
		marginLeft: 5,
		paddingRight:50
	},
    text2: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
    
    text4: {
		fontSize: 30,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text5: {
		fontSize: 23,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text6: {
		fontSize: 22,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	text3: {
		marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'center',
		fontSize: Dimensions.get('window').width/70,
		color:'#03C04A',
		marginRight: Dimensions.get('window').width/5,
		marginLeft: Dimensions.get('window').width/5,
		
	},
	  textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:Dimensions.get('window').width/2.5,
		paddingLeft: Dimensions.get('window').width/2.5,
		paddingBottom: 30,
		textAlign: 'center',

	  },
	  textArea: {
		height: 50,
		width:250,
		fontSize: 16,
		borderColor: 'white',
		backgroundColor:'white',
		color:'black',
		borderWidth: 1,
		marginBottom: 20,
		justifyContent: "center"
	  },
	  checkboxContainer: {
		flexDirection: "row",
		
	  },
	  checkbox: {
		alignSelf: "center",
	  },
})
export default Info